export var precision = function (num) {
    return (num.toString().split(".")[1] || []).length;
};
export var isDecimal = function (num) {
    return !isNaN(num) && num % 1 > 0;
};
